import * as React from 'react';
import { connect } from 'react-redux';
import { setPlanes, setId, setDataGrupo, setPlanesDesdeBusqueda } from '../../actions/planesActions';
import { postGrupoPlanes } from '../../api/axios';
import { toast } from 'react-toastify';
import Cleave from 'cleave.js/react';

class PlanesNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            request: null,
            descripcion: "",
            comision: 0,
        }
    };

    componentDidMount() {
        this.setState({
            request: this.props.planes
        })
    }

    onSubmit = async (event) => {
        event.preventDefault();
        if (this.props.dataGrupo.descripcion == "" || this.props.dataGrupo.comision == "") {
            if (this.props.dataGrupo.descripcion == "") {
                toast.error("Debe agregar una descripción");
            }
            if (this.props.dataGrupo.comision == "") {
                toast.error("Debe agregar una comisión");
            }
            return;
        }
        let idPlanes = [];
        for (let index = 0; index < this.props.planDesdeBusqueda.length; index++) {
            idPlanes.push(this.props.planDesdeBusqueda[index].id);
        }

        if (JSON.stringify(idPlanes) == "[]") {
            toast.error("Debe agregar planes");
            return;
        }
        let data = {
            descripcion: this.props.dataGrupo.descripcion,
            comision: parseFloat(this.props.dataGrupo.comision),
            listaIdsPlanes: idPlanes
        }

        let post = postGrupoPlanes(data);
        post.then(res => {
            toast.success("Grupo de planes guardado");
            this.return();
        }).catch(err => {
            toast.error("No pudo guardarse");
        });

    }

    borrarFila = (item) => {
        let index = this.props.planDesdeBusqueda.findIndex(x => x.numero == item.numero);
        this.props.planDesdeBusqueda.splice(index, 1);
        this.props.setPlanesDesdeBusqueda(this.props.planDesdeBusqueda)
        this.forceUpdate();
    }


    filaPlanes = () => {
        var rows = [];
        let htmlData;
        if (this.state.request != null) {
            this.props.planDesdeBusqueda.map((item) => {
                htmlData = <tr className="hover-background-color">
                    <td class="div-center">{item.numero}</td>
                    <td>{item.descripcion}</td>
                    <td onClick={() => this.borrarFila(item)}><i class="fas fa-trash-alt"></i></td>
                </tr>
                rows.push(htmlData)
            });
        }
        return rows;
    }

    myChangeHandler = (e) => {
        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name == "comision") {
            let esNumero = valor.match(numbersOnly);
            if (esNumero == null) {
                document.getElementById("comisionId").value = "";
                return;
            }
            if (e.target.value > 100) {
                document.getElementById("comisionId").value = "";
            } else {
                this.props.setDataGrupo({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
            }
        } else {
            this.props.setDataGrupo({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
        }
    }



    goToBusqueda = () => {
        this.props.setId("Nuevo");
        setTimeout(() => { this.props.history.push("/Planes/Busqueda"); }, 500)
    }

    return = () => {
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setPlanes([]);
        this.props.history.push("/Planes");
    }

    render() {

        return (

            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body p-b-0">

                        <form className="form-horizontal form-material   p-10" onSubmit={this.onSubmit}>
                            <div className="tab-content">

                                <div className='row align-items-center'>
                                    <div className="col">
                                        <h4 className="card-title">Nuevo grupo planes</h4>
                                    </div>
                                    <div className="col-auto text-right">
                                        <button type="button" onClick={this.goToBusqueda} className="btn btn-sm background-rojo-megatone m-r-10">
                                            <i className="fa fa-plus-circle"></i> Agregar planes
                                        </button>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label className="label-oscura">Descripción</label>
                                            <input name="descripcion" type="text" value={this.props.dataGrupo.descripcion} onChange={this.myChangeHandler} id="firstName" class="form-control"></input>
                                        </div>
                                        <div class="col-md-6">
                                            <small className=" font-14  applyFont"><i className="fas fa-percent"></i></small>
                                            <label className="label-oscura">&ensp;Comisión</label>
                                            <Cleave id="comisionId" name="comision" value={this.props.dataGrupo.comision == 100 ? 100 : this.props.dataGrupo.comision} onKeyUp={this.myChangeHandler} className="form-control"
                                                options={{ blocks: [5], numericOnly: false }} />
                                        </div>
                                    </div>
                                </div>

                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th class="div-center">Número plan</th>
                                            <th>Descripción plan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.filaPlanes()
                                        }
                                    </tbody>
                                </table>

                                <div className='d-flex justify-content-center'>
                                    <button type="submit" className="btn  btn-sm background-rojo-megatone waves-light m-r-10">Guardar</button>
                                    <button onClick={this.return} class="btn btn-sm btn-light waves-effect waves-light">Cancelar</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        );
    }

}


const mapStateToProps = state => (
    {
        dataGrupo: state.planes.dataGrupo,
        planes: state.planes,
        planDesdeBusqueda: state.planes.planesDesdeBusqueda
    });
export default connect(mapStateToProps, { setPlanes, setId, setDataGrupo, setPlanesDesdeBusqueda })(PlanesNew); 